/**
 * NUTTYMONSTER cart drawer extras (lean version)
 * - Upsell / slider quick-add (refreshes the drawer through the theme's own cart events)
 * - Variant picker price update
 * - Slider arrows
 * Nothing runs on timers or observers; everything is event delegation on document.
 */
import { CartAddEvent } from '@theme/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/* ---------------- Variant price ---------------- */
document.addEventListener('change', (event) => {
  const select = event.target instanceof Element && event.target.closest('[data-nm-upsell-variant]');
  if (!select) return;

  const option = select.selectedOptions[0];
  const priceEl = select.closest('form')?.querySelector('[data-nm-upsell-price]');
  if (!option || !priceEl) return;

  const compare = option.dataset.compare;
  priceEl.innerHTML = `<span>${option.dataset.price}</span>` + (compare ? ` <s class="compare-at-price">${compare}</s>` : '');
});

/* ---------------- Quick add ---------------- */
document.addEventListener('submit', async (event) => {
  const form = event.target instanceof Element && event.target.closest('[data-nm-upsell-form]');
  if (!form) return;
  // On the cart page, let the form post normally (adds the item and reloads the cart)
  if (!form.closest('cart-drawer-component, .cart-drawer')) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const errorEl = form.querySelector('[data-nm-upsell-error]');
  const variantId = form.querySelector('[name="id"]')?.value;
  if (!variantId) return;

  button?.setAttribute('aria-busy', 'true');
  if (errorEl) errorEl.hidden = true;

  const sectionIds = [
    ...new Set(
      [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean)
    ),
  ];

  try {
    const addResponse = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const added = await addResponse.json();

    if (!addResponse.ok || added.status) {
      throw new Error(added.description || added.message || 'Could not add to cart. Please try again.');
    }

    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

    // Let the theme refresh the drawer, cart count bubble etc.
    form.dispatchEvent(
      new CartAddEvent(cart, 'nm-cart-upsell', {
        source: 'nm-cart-upsell',
        itemCount: cart.item_count,
        variantId: String(variantId),
        sections: added.sections,
      })
    );
  } catch (error) {
    if (errorEl) {
      errorEl.textContent = error instanceof Error ? error.message : 'Something went wrong.';
      errorEl.hidden = false;
    }
    button?.removeAttribute('aria-busy');
  }
});

/* ---------------- Slider arrows ---------------- */
function nmSliderUpdate(track) {
  const slider = track.closest('[data-nm-slider]');
  if (!slider || !track.clientWidth) return;
  const max = track.scrollWidth - track.clientWidth - 2;
  const prev = slider.querySelector('[data-nm-slider-nav="-1"]');
  const next = slider.querySelector('[data-nm-slider-nav="1"]');
  if (prev) prev.disabled = track.scrollLeft <= 2;
  if (next) next.disabled = track.scrollLeft >= max;
}

document.addEventListener('click', (event) => {
  const arrow = event.target instanceof Element && event.target.closest('[data-nm-slider-nav]');
  if (!arrow) return;
  const track = arrow.closest('[data-nm-slider]')?.querySelector('[data-nm-slider-track]');
  if (!track) return;
  const card = track.querySelector('.nm-slide');
  const step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth;
  const dir = Number(arrow.getAttribute('data-nm-slider-nav')) || 1;
  track.scrollBy({ left: dir * step, behavior: 'smooth' });
  setTimeout(() => nmSliderUpdate(track), 400);
});

document.addEventListener(
  'scrollend',
  (event) => {
    const el = event.target;
    if (el instanceof Element && el.matches('[data-nm-slider-track]')) nmSliderUpdate(el);
  },
  true
);
